import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PlanHome } from "@plans/tiles";
import { ReviewDetailsModal } from '@plans-templates/review-details';
import { TextLink } from '@vds/buttons';
import InfoIcon from '@vds/icons/info';
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Body } from '@vds/typography';
import { updateSCTags as ecupdateSCTags, updateSCcustomEvent as ecupdateSCcustomEvent, tempSCData } from './../../../../Source/src/service/change/dtmTag';
import { updateDetailValue as ecupdateDetailValue } from './../../../../Source/src/service/change/vzdl';
import { updateSCTags } from './../../../../Source/src/service/dtmTag';
import { updateVzdlSCCustomEvent, tempVzdlSCData, updateDetailValue } from './../../../../Source/src/service/vzdl';
import { ProductType, Service } from '../../constants/actionType';
import { useTileTheme } from '../../contexts/tileThemeContext';
import { useMobileView } from '../../hooks/useMobileView';
import { getFootNoteOnSpecialGift, InHomeUtils, populateFootNotes } from './../../util/inhomeUtils';
import { getCmsData, getPerkGiftDts, hasPerkGift } from '../midnight/services/dataFormatter';
import { YouTubeBannerDetails } from './DiscountFlowModal';
import GiftCardModal from './giftCardModal';
import MnhModal from './mnhModal';
import { store } from "../../index";
import ReactHtmlParser from 'react-html-parser';

const YoutubeTvTooltipModal = React.lazy(() => import("./youtubeTvTooltipModal"));

function EmberPlanHome(props) {
  const { product, clickFn, lqState, serviceType, buildProduct, isChecked, achorLinkTitleForTV, openModal, handleClickFiosFive, signInClick, ecProfileCart, signIn, profileCart, isBlocked, flowType, acc = false, onClickAccordion = () => { }, } = props;
  const { isCloseBtnClick = false, setIsCloseButton = () => { }, selectedSplOfferDetailsId = null, setSelectedSplOfferDetailsId = () => { }, } = props;
  const [priceGuaranteeBrandPromise, setpriceGuaranteeBrandPromise] = useState([]);
  const tileTheme = useTileTheme();
  const isECFlow = flowType === "EC" || window.location.pathname.includes("/change/");
  const isClassicFlow = !buildProduct?.mnFromApi;
  const isMobileView = useMobileView();
  const isMNHSignupIndicator = buildProduct?.internet?.mnhSignupIndicator === "Y" || buildProduct.isStaticMnhEnable;
  const isEmployee = lqState.couponFlowType === 'Employee' || lqState.couponFlowType === 'Retiree' || (signIn && signIn?.ecFlowType && (signIn?.ecFlowType === 'Employee' || signIn?.ecFlowType === 'Retiree'));
  const isDiscountFlow = lqState.MFRTEligible && InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow && InHomeUtils.isNotNull(lqState.SweetnerMsgMFRT) && InHomeUtils.isNotNull(lqState.SweetnerMsgMFRT.discountEligible) && lqState.SweetnerMsgMFRT.discountEligible;
  let isShowAsLowPrice = true;
  const isDisconnectFlow = signIn?.response?.flowRoute === "FULLDISCONNECT";
  const isNotVerizonEmployee = buildProduct?.internet?.vzEmployee === false
  const hasYouTubeProfile = profileCart?.cartData?.[0]?.streamService?.streamServiceProds?.findIndex(items => items?.prodName?.toUpperCase()?.includes("YOUTUBE TV")) > -1 || ecProfileCart?.cartData?.[0]?.streamService?.streamServiceProds?.findIndex(items => items?.prodName?.toUpperCase()?.includes("YOUTUBE TV")) > -1 ? true : false;
  const hasYoutubeTvTooltip = !buildProduct?.isVZFCreditFlag && !isClassicFlow && product?.displayPrice?.replace?.("$", "") != 0.0 && !hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE';
  const [isYoutubeTvTooltipOpen, setYoutubeTvTooltipOpen] = useState(false);
  let localTv = isECFlow ? 'localTVheight' : 'localTV_NCheight'
  const dataFootNotes = populateFootNotes(buildProduct?.internet?.m2mPlans);
  const tvFootNotes = populateFootNotes(buildProduct?.tv?.m2mPlans);
  useEffect(() => {
    let promotions = ecProfileCart?.cartData?.[0]?.Promotions?.promotions;
    if (Array.isArray(promotions) && promotions?.length > 0) {
      let newPriceGuaranteeArr = [];
      for (let i = 0; i < promotions.length; i++) {
        if ((promotions[i]?.prodType == "PRICELOCK" || promotions[i]?.prodType == "PRICELOCK_EXT") && (promotions[i]?.name)) {
          let text = promotions[i]?.name;
          text = text?.replace?.("Year Internet Price Guarantee", "-year price lock guarantee");
          text = text?.replace?.(" internet", "");
          newPriceGuaranteeArr.push(text);
        }
      }
      if (newPriceGuaranteeArr.length > 0) {
        const order =["Year Internet Price Guarantee","1 Year Price Guarantee Extension"];
        const sortedGuaranteeArr = newPriceGuaranteeArr.sort((a,b)=>{
          return order.indexOf(a) - order.indexOf(b);
        });
        setpriceGuaranteeBrandPromise(sortedGuaranteeArr);
      }
    }
  }, [ecProfileCart?.cartData])
  const productNameChannelLabel = () => {
    let prodLabel = "";
    if (product?.name) {
      prodLabel = product?.name?.replace?.('4.0', '')?.trim?.();
    }
    return prodLabel;
  };

  const getsplOferFrmApiAriaLabel = () => product?.splOferFrmApi?.trim() ? `${product?.productName} ${product?.splOferFrmApi}` : `A special gift, on us for ${product?.productName}`

  const getStrikeOutPrice = () => {
    // Employee flow checks
    if (buildProduct?.internet?.typeOfDiscountScenario || isEmployee || buildProduct?.isVZFwdFlag || buildProduct?.isVZFCreditFlag || isDiscountFlow || isMNHSignupIndicator) {
      if (serviceType === Service.internet && buildProduct?.internet && (isEmployee || isMNHSignupIndicator || buildProduct?.internet?.strikePrice === "Y" || buildProduct?.internet?.typeOfDiscountScenario)) {
        let dPrice = product?.displayPrice;
        let oPrice = product?.originalPrice;
        let strikedOffPrice
        if (isMNHSignupIndicator) {
          strikedOffPrice = ((parseFloat(oPrice?.replace?.("$", "")) - 10)?.toFixed?.(2));
        } else {
          strikedOffPrice = "$" + ((parseFloat(oPrice?.replace?.("$", "")) - 10)?.toFixed?.(2));
        }
        if (isEmployee) {
          strikedOffPrice = ((parseFloat(oPrice?.replace?.("$", "")))?.toFixed?.(2));
        }
        //Making this change as we need to show striked price as originalPrice -10 after MnHSignup not original price
        if (buildProduct?.internet?.typeOfDiscountScenario) {
          //Making this change as we need to show striked price as originalPrice -10 after MnHSignup
          // let disPlayPrice = oPrice;
          // if(!buildProduct?.isAPDataEnabled){
          //   disPlayPrice = ((parseFloat(dPrice?.replace("$", "")) + 10).toFixed(2));
          //   return disPlayPrice !== oPrice ? disPlayPrice : '';             
          // }          
          // return disPlayPrice;
          return oPrice?.replace?.("$", "");
        }
        let diffprice = parseFloat(strikedOffPrice?.replace?.("$", "")) - parseFloat(dPrice?.replace?.("$", ""));
        if (diffprice > 0 || diffprice < 0) {
          return strikedOffPrice;
        }
      }
    }
    const isGig = product?.id === "R3583" || product?.id === "R3582";
    const is20SpclOffer = product?.specialOffersfromApi?.findIndex(item => ["R4017"].includes(item.id)) > -1 ? true : false;
    const is10DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4021"].includes(item.id)) > -1 ? true : false;
    //const is10NEWDisc = product?.specialOffersfromApi?.findIndex(item => ["R4616"]?.includes(item?.id)) > -1 ? true : false;
    //const is15NEWDisc = product?.specialOffersfromApi?.findIndex(item => ["R4617"]?.includes(item?.id)) > -1 ? true : false;
    const is15DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4032"].includes(item.id)) > -1 ? true : false;
    const is25DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4033"].includes(item.id)) > -1 ? true : false;
    if (is20SpclOffer || is10DiscOffer  || is15DiscOffer || is25DiscOffer || buildProduct?.internet?.mnhSignupIndicator === "Y") {
      let originalPrice = product?.originalPrice;
      let strikedPrice = "";
      if (buildProduct?.isAPDataEnabled) {
        strikedPrice = ((parseFloat(originalPrice?.replace?.("$", "")) - 10)?.toFixed?.(2));
      } else {
        strikedPrice = ((parseFloat(originalPrice?.replace?.("$", "")))?.toFixed?.(2));
      }
      return strikedPrice;
    }
    return '';
  };

  const generateClassicDisplayPrice = (y, product) => {
    if (y && y.indexOf("/mo") > -1) {
      y = y?.replace?.("/mo", "");
    }
    if (y == "$0" || y == "$0.00" || y == "$0.0") {
      y = "Included"
    }
    else if (y && y.indexOf(".00") > -1 && y.indexOf("less") == -1 && y.indexOf("more") == -1) {
      y = y?.replace?.(".00", "");
    }
    else if (y && y.indexOf(".00 less") > -1) {
      y = y?.replace?.(".00 less", " less");
    }
    else if (y && y.indexOf(".00 more") > -1) {
      y = y?.replace?.(".00 more", " more");
    }

    const finalPrice = y?.includes?.('$0') || product?.prodType === 'PREMIUM' || product?.prodType === 'INTLPREMIUM' ? '' : y?.replace?.('$', '');
    if (y == "Included") {
      return {
        pricingText: {
          title: {
            children: <>{y}</>
          }
        }
      }
    } else {
      return {
        ...(finalPrice && {
          newPrice: {
            price: finalPrice,
            term: "month",
            superscript: "*"
          }
        })
      };
    }
  }

  const getIcon = item => {
    const icons = {
      speed: 'speed-monitoring',
      wifi: 'home-internet',
      router: 'home-internet',
      price: 'lock-closed',
      gift: 'gift',
      voice: 'voice-hd',
      dvr: 'pause',
      storage: 'cloud',
      cloud: 'cloud',
      streaming: 'cross-device',
      stream: 'cross-device',
      accounts: 'cross-device',
      channel: 'tv',
      mgm: 'find-my-remote',
      set: 'top-box',
      rental: 'top-box',
      // international:'alternate-checkmark',
      order: 'tag',
      new: 'tag',
      paramount: 'find-my-remote',
      cancel: 'no',
      access: 'home-internet'
    };
    const ic = Object.keys(icons)?.find(icon => {
      if (item.toLowerCase().includes(icon) && !item.toLowerCase().includes('recommend')) {
        return icon;
      }
    });
    return icons[ic];
  };

  const handleCloseSignClick = (e) => {
    if (e === false && !isCloseBtnClick) {
      updateSCTags('Close sign');
    } else {
      setIsCloseButton(false);
    }
    setSelectedSplOfferDetailsId(null);
  }

  const getSubTitleForSplOffer = prodId => {
    if (prodId === 'R4010' || prodId === 'R4011' || prodId === 'R4009') {
      return <Body size='small' color='#6E6B65'>
        $10/mo after. Select Disney Bundle Perk to receive offer.
      </Body>
    } else if (prodId === 'R4047' || prodId === 'R4142') {
      return <Body size='small' color='#6E6B65' primitive='span'>
        $10/mo after&nbsp;
      </Body>
    } else if (prodId === 'R4049' || prodId === 'R4140') {
      return <Body size='small' color='#6E6B65' primitive='span'>
        Xbox Stereo Headset, Xbox Wireless Controller and $50 Xbox gift card.&nbsp;
      </Body>
    } else {
      return <></>;
    }
  }

  const getSpecialOfferReviewDetails = (prodId, offerText, style = {}) => {
    try {
      const internetCmsProds = getCmsData();
      const cmsProds = internetCmsProds?.[prodId];
      const productReviewDts = cmsProds && cmsProds?.reviewDetails ? cmsProds?.reviewDetails : [];

      if (Array.isArray(productReviewDts) && productReviewDts.length > 0) {
        productReviewDts?.shift();
      }
      if (productReviewDts?.length > 0) {
        return (
          <div style={style}>
            {
              getSubTitleForSplOffer(prodId)
            }
            <Modal
              onClose={(e) => { handleCloseSignClick(e) }}
              opened={selectedSplOfferDetailsId === prodId}
              onOpenedChange={(e) => setSelectedSplOfferDetailsId(prodId)}
              toggleButton={
                <span onClick={(e) => { updateSCTags('Details'); setSelectedSplOfferDetailsId(prodId) }}><TextLink role="button" ariaLabel={"Details " + offerText}>
                  Details</TextLink>
                </span>
              }
              id={`${isMobileView ? 'mnTile_reviewModal_mobile' : 'mnTile_reviewModal'}`}
            >
              {productReviewDts?.map(item => {
                let processedTitle = ((prodId === 'R4047' || prodId === 'R4142' || prodId === 'R4261') && product?.name?.toLowerCase()?.includes("2 gig")) ?
                "Get Netflix & Max (With Ads) Perk for 12 months, on us with the 2 Gig plan." : (prodId === 'R4047' || prodId === 'R4142' || prodId === 'R4261' && product?.name?.toLowerCase()?.includes("1 gig")) ?
                  "Get Netflix & Max (With Ads) Perk for 12 months, on us with the 1 Gig plan." : (prodId === 'R4261' && product?.name?.toLowerCase()?.includes("500 mbps") ) ? "Get Netflix & Max (With Ads) Perk for 12 months, on us with the 500 Mbps plan." :  item?.title
                if (prodId === "R4540" && product?.name) {
                  processedTitle = `Get YouTube Premium for 6 months, on us with the ${product?.name?.replace?.("4.0", "")?.trim?.()} plan.`;
                }
                return (
                  <>
                    <ModalTitle>
                      <span dangerouslySetInnerHTML={{ __html: processedTitle }}></span>
                    </ModalTitle> 
                    <ModalBody>
                      {
                        product?.id === "R0529" || product?.id === "NOCEAPPS" ? <>
                          <img alt="FireTv" src={require('./../../assets/ak-cached/24h/img/streaming/apple-tv-4k-32gb.jpeg').default} width="100px" />
                          <img alt="FireStick" src={require('./../../assets/ak-cached/24h/img/streaming/Fire-Stick.jpeg').default} width="100px" />
                          <img alt="FireTv" src={require('./../../assets/ak-cached/24h/img/streaming/Fire-Cube.jpeg').default} width="100px" />
                          <img alt="StreamTV" src={require('./../../assets/ak-cached/24h/img/streaming/Stream-TV.png').default} width="100px" />
                        </> : <></>
                      }
                      <span dangerouslySetInnerHTML={{ __html: item?.subtitle }}></span>
                      {
                        item?.helperText ?
                          <span style={{ fontSize: '11px' }} dangerouslySetInnerHTML={{ __html: item?.helperText }} />
                          : <></>
                      }
                    </ModalBody>
                    <ModalFooter
                      buttonData={{
                        primary: {
                          width: '100%',
                          children: (prodId === 'R4010' || prodId === 'R4011' || prodId === 'R4009' || prodId === "R4339") ? 'Got it' : 'Close',
                          onClick: () => {
                            setIsCloseButton(true)
                            updateSCTags("close button")
                            setSelectedSplOfferDetailsId(null);
                            setTimeout(() => {
                              try {
                                document.getElementById('close-button').click()
                              } catch (e) {
                                //console.error(e);
                              }
                            }, 1000)
                          }
                        }
                      }}
                    ></ModalFooter>
                  </>
                )
              })}
            </Modal>
          </div>
        )
      }
    } catch (e) {
      return null;
    }
  }

  const formatExtrasForData = prod => {
    // const saveTheSaleOffersRestrictDisplay = ['R3883', 'R3884','R3885'];
    // const removeOffersSpl = ["Q9938", "Q9939", "Q9940", "Q9944", "Q9945", "Q9946", "Q9947", "P0256", "P0257", "Q9942", "Q9941", "Q9943", "P0255", "P0254", "R1987", "R1986", "P0256", "Q9947", "Q9951", "Q9952", "Q9953" ]
    // const splRemoveofferList =["R1345", "Q9938", "Q9939", "Q9941", "Q9942", "Q9943", "Q9951", "Q9947", "Q9940","R1986", "R1987", "P0255", "P0256", "P0254", "P0257","P0256", "Q9947", "Q9946", "Q9945", "Q9944", "Q9951", "Q9952", "Q9953" ]
    let is500Plan = prod?.name?.toLowerCase()?.includes("500")
    let is500Plans = prod?.name?.toLowerCase()?.includes("500m")
    let isGigPlans = prod?.name?.toLowerCase()?.includes("gig")
    const onUS = <span style={{fontSize:'0.75rem',fontWeight:'700'}}>on us</span>
    const contentObj = [];

    let specialOffersfromApiArr = prod?.specialOffersfromApiArr?.[0];

    let special = specialOffersfromApiArr?.filter((spl) => spl?.id == "R4142");
    if (special?.length > 0) {
      specialOffersfromApiArr = specialOffersfromApiArr?.filter(i => !(
        i?.id === 'R4093'  // black friday xbox series s
      ))
    }

    let specialstarz = specialOffersfromApiArr?.filter((spl) => spl?.id == "R4261");
    let titleName = false;
    if(specialstarz?.length > 0){
      titleName = true;
    }

    let leadChoice = specialOffersfromApiArr?.filter((spl) => spl?.id == "R4586" || spl?.id == "R4587" || spl?.id == "R4570"  || spl?.id == 'R4677');
    let choiceName = false;
    if(leadChoice?.length > 0){
      choiceName = true;
    }


    if (specialOffersfromApiArr?.length > 0) {
      contentObj.push({
        title: {
          children: titleName ? 'Included on us:' : ( choiceName ? 'Choice of:' : 'Your choice of:')
        },
        // items: prod?.specialOffersfromApiArr?.[0]?.filter((isocid) => !splRemoveofferList?.includes(isocid?.id))?.map(extra => {
        items: specialOffersfromApiArr?.filter((spl) => spl?.offerFor === 'Data' && spl?.BsOfferAttrValue !== 'NETMAX_PERK_MARKER')?.map((extra,index) => {

          return {
            title: {
              children: <Body color='#000000'>
                <span style={{ fontWeight: "bold" }}>{getFootNoteOnSpecialGift(extra?.OfferText?.replace?.('Samsung TV on us','Samsung TV'), dataFootNotes, lqState, flowType, false, extra?.id)}</span>
              </Body>
            },
            subtitle: {
              children: <>{getSpecialOfferReviewDetails(extra?.id, extra?.OfferText)}
              {(specialOffersfromApiArr?.length === index+1 && !titleName  ? '' : 
                <div className= "choiceofferOR">{'OR'}</div>)}
              </>
            }
          }
        })
      });
    }
    console.log('prod?.specialOffersfromApiArr', prod?.specialOffersfromApiArr)
    const promosList = prod?.specialOffersfromApiArr?.[1]?.filter?.((spl) => spl?.offerFor === 'Data' && spl?.BsOfferAttrValue !== 'NETMAX_PERK_MARKER' && spl?.BsOfferAttrValue !== '$50_XBOX_BUNDLE_GC_DISCOUNT_CM24' && spl?.BsOfferAttrValue !== '$10_AutoPay' && spl?.BsOfferAttrValue !== "SETUPFEE" && !(spl?.BsOfferAttrValue === "$2.10" && isGigPlans));

    const hasChoiceOffer = specialOffersfromApiArr?.length > 0 ? specialOffersfromApiArr?.some?.(item=> item?.extendedAttributes?.toUpperCase?.()?.includes?.("ISCHOICE:YES")) : false;

    if (Array.isArray(promosList) && promosList?.length > 0) {
      let isGigPlans = prod?.name?.toLowerCase()?.includes("gig")
      contentObj.push({
        ...(isGigPlans || prod?.id == "R3584" 
          ? {
            title: {
              children: !titleName && prod?.specialOffersfromApiArr?.length > 0 && hasChoiceOffer ?  "Also included on us:" : ""
            }
          }
          : null
        ),
        // items: prod?.specialOffersfromApiArr?.[1]?.filter((isocid) => !saveTheSaleOffersRestrictDisplay?.includes(isocid?.id) && !removeOffersSpl?.includes(isocid?.id))?.map(extra => {
        items: promosList?.map?.(extra => {
          return {
            // title: {
            //   children: <Body color='#000000' >
            //     <span style={{ fontWeight: "bold" }}>  {is500Plan && is500Plans ? ('Bonus: ' + extra?.OfferText?.replace?.('1 Gig', '500 Mbps')) : (extra?.id == "R4139" ? extra?.OfferText?.replace?.('Console On Us', '') : extra?.OfferId == "40001" || extra?.OfferId == "40002" || extra?.OfferId == "39845" || extra?.OfferId =="39863" ? extra?.OfferText?.replace?.('Bonus:', '')?.replace?.('on Us', '')?.replace?.('on us', '') :<>{'Bonus: '}{getFootNoteOnSpecialGift(extra?.OfferText?.replace?.('on us', '')?.replace?.('on Us', '')?.replace?.('Credit','trial'), dataFootNotes, lqState, flowType)}</>)}</span>
            //     { extra.OfferId =="39863"  ? <span>{extra.OfferId =="39863" ? <span style={{ paddingLeft: '2px'}}>{onUS} $10.99/mo after</span> :  ''}</span> : '' }
            //   </Body>
            // },
            subtitle: {
              children: <>
                <span style={{ color: "black", fontWeight: "bold" }}>
                  {is500Plan && is500Plans
                    ? ('Bonus: ' + extra?.OfferText?.replace?.('1 Gig', '500 Mbps'))
                    : (extra?.id == "R4139"
                      ? extra?.OfferText?.replace?.('Console On Us', '')
                      : extra?.OfferId == "40001" || extra?.OfferId == "40002" || extra?.OfferId == "39845" || extra?.OfferId == "39863"
                        ? extra?.OfferText?.replace?.('Bonus:', '')?.replace?.('on Us', '')?.replace?.('on us', '')?.replace?.('for','')
                        : (extra?.extendedAttributes?.toUpperCase()?.includes?.("TILEDISPLAY:YES"))
                          ? extra?.BsOfferAttrValue === 'TwoMonths_Internet_disc' ? getFootNoteOnSpecialGift(extra?.OfferText, dataFootNotes, lqState, flowType, false, extra?.id) :  getFootNoteOnSpecialGift(extra?.OfferText?.replace?.('for','')?.replace?.('on us', ''), dataFootNotes, lqState, flowType, false, extra?.id)
                          : <>{'Bonus: '}{getFootNoteOnSpecialGift(extra?.OfferText?.replace?.('on us', '')?.replace?.('on Us', '')?.replace?.('Credit', 'trial')?.replace?.('for',''), dataFootNotes, lqState, flowType, false, extra?.id)}</>
                    )}
                </span>
                {extra.OfferId == "39863"
                  ? <span style={{ color: "black" }}>
                    {extra.OfferId == "39863"
                      ? <span style={{ paddingLeft: '2px' }}>{onUS} $10.99/mo after</span>
                      : ''
                    }
                  </span>
                  : ''}
                <span>
                  {" "}{getSpecialOfferReviewDetails(extra?.id, extra?.OfferText, { display: "inline" })}
                </span>
              </>
            }
          }
        })
      });
    }

    return {
      header: {
        badge: {
          children: (
            <>
              <span
                aria-label={`A special gift, on us ${product?.productName}`}
              >
                <span aria-hidden="true">A special gift, on us </span>
              </span>
            </>
          ),
          fillColor: "red",
        },
        title: {
          children: ReactHtmlParser(prod?.splOferFrmApi),
        },
        ariaLabel: getsplOferFrmApiAriaLabel(),
      },
      content: contentObj,
      onClick: serviceType === Service.internet ? null : onClickAccordion,
      open: acc,
    };
  };

  const handleDetails = (e, extra, prod) => {
    let name = prod?.productName?.replace?.("4.0", "");
    if (flowType == "EC") {
      //  tempSCData.detailPageName= name;
      ecupdateDetailValue(name);
      tempSCData.detailPageName = extra?.OfferText + " - details";
      ecupdateSCcustomEvent(
        "buildFiosInitEC",
        "pageViewOmni",
        "detailPageName,events"
      );
      ecupdateSCTags("Details");
    }
    else if (props.lqState.streamlineLQ === true){
      setTimeout(() => {
        tempVzdlSCData.detail = name;
        updateDetailValue(name);
        updateSCTags("Details");
      }, 1000);
      tempVzdlSCData.detail = extra?.OfferText + " - details";
      tempVzdlSCData.name = "Streamline Buildproducts - TV & Voice"
      updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,events,name");
    }
     else {
      setTimeout(() => {
        tempVzdlSCData.detail = name;
        updateDetailValue(name);
        updateSCTags("Details");
      }, 1000);
      tempVzdlSCData.detail = extra?.OfferText + " - details";
      updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,events");
    }
  };

  const formatExtras = prod => {
    return {
      badge: {
        children: 'A special gift, on us',
        fillColor: prod?.name === '1 Gig' || prod?.name === '2 Gig' || prod?.name === '2 Gig 4.0' ? 'red' : prod?.type === 'TV' ? 'red' : 'white'
      },
      content: <>
        {prod?.extras?.map(extra => {
          return <Body color='#000000'>
            {getFootNoteOnSpecialGift(extra?.OfferText, tvFootNotes, lqState, flowType, false, extra?.id)}
            {(typeof extra?.OfferText === "string" && extra?.OfferText?.toUpperCase()?.includes("VERIZON GIFT CARD")) && (
              <span onClick={(e) => { handleDetails(e, extra, prod) }}>
                &nbsp; <GiftCardModal title={extra?.OfferText} />
              </span>
            )}
          </Body>
        })}
      </>
    }
  };

  const getAsLowAsPrice = () => {
    const mnhSignupIndicator = ((buildProduct?.internet?.mnhSignupIndicator == 'Y') || buildProduct.isStaticMnhEnable === true )? 'Y' : '';
    const isMax500plan = buildProduct?.internet?.m2mPlans?.findIndex(item => ["R3582", "R3583"].includes(item?.id)) == -1;
    const isGigPlan = buildProduct?.internet?.m2mPlans?.findIndex(item => ["R3582", "R3583"].includes(item?.id)) > -1;
    const is25MNHOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["R3726", "R3728", "R3729", "R4033"].includes(item?.id)) > -1
    const is15MNHOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["R3725", "R3727", "R4032"].includes(item?.id)) > -1
    const isTWSFlow = buildProduct?.internet?.typeOfDiscountScenario === "TWS" || buildProduct?.internet?.typeOfDiscountScenario === "TSW" || buildProduct?.isTWSFlag === "Y";
    const is10TWSOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["38412"].includes(item?.OfferId)) > -1
    const is5TWSOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["37486"].includes(item?.OfferId)) > -1
    const price = (+product?.price);
    const is20SpclOffer = product?.specialOffersfromApi?.findIndex(item => ["R4017"].includes(item.id)) > -1 ? true : false;
    let is15DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4032"].includes(item.id)) > -1 ? true : false;
    let is25DiscOffer = product?.specialOffersfromApi?.findIndex(item => ["R4033"].includes(item.id)) > -1 ? true : false;
    // If autopay is enabled then add autopay discount 
    let autopayDiscount = 0;
    let autopayPrice = 0;
    product?.specialOffersfromApi?.map?.((item, index) => {
      if(item?.BsOfferAttrValue?.toLowerCase()?.includes?.("autopay") && !item?.BsOfferAttrValue?.toLowerCase?.()?.includes?.("decline")){        
        autopayPrice = Number(item?.Price);
      }
    });
    autopayDiscount = buildProduct?.isAPDataEnabled ? 0 : autopayPrice;
    // Add mnh discount depending on mnhSignupIndicator, internet plan, and special offers
    let mnhDiscount = 0;
    let mnhTooltipdesc="";
    if (mnhSignupIndicator === "Y" && (is25MNHOfferAvailable || is15MNHOfferAvailable)) {
      mnhDiscount = 0;
    } else if ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !is25MNHOfferAvailable && !is15MNHOfferAvailable) {
      mnhDiscount = (+product?.mnhDiscount);
    } else if (
      (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && isGigPlan && !isMax500plan)
      || (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && isMax500plan && (product?.id == "R3584"))
    ) {
      mnhDiscount = 25;
    } else if (
      (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && !isMax500plan)
      || (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && isMax500plan && (product?.id != "R3584"))
    ) {
      mnhDiscount = 15;
    } else if (
      ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && isGigPlan && !isMax500plan && is25MNHOfferAvailable && !is15MNHOfferAvailable)
      || ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !isGigPlan && isMax500plan && (product?.id == "R3584") && is25MNHOfferAvailable && !is15MNHOfferAvailable)
    ) {
      mnhDiscount = -25;
    } else if (
      ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !isGigPlan && !isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable)
      || ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !isGigPlan && isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable)
    ) {
      mnhDiscount = -15;
    } else {
      mnhDiscount = 0;
    }
    // Add tws discount depending on special offers
    let twsDiscount = 0;
    if (isTWSFlow && is10TWSOfferAvailable) {
      twsDiscount = 10;
    } else if (isTWSFlow && is5TWSOfferAvailable) {
      twsDiscount = 5;
    }
    
    // Calculate as low as price
    let asLowAsPrice = price - mnhDiscount - twsDiscount + autopayDiscount; // PRODDEF-34778: D/T/M_FiosNC_M+H Pricing when APO toggle off is Incorrect i.e. It should increase by 10 if APO is toggle off
    if (asLowAsPrice < 0) {
      asLowAsPrice = 0;
    }
    if (is15DiscOffer || is25DiscOffer) {
      let deductionPrice = is15DiscOffer ? 15
        : is25DiscOffer ? 25
          : 0;
      let asLowAsPrice = (parseFloat(product?.displayPrice?.replace?.("$", "")) - deductionPrice)?.toFixed?.(2);
      return asLowAsPrice;
    }
    if (is20SpclOffer && isGigPlan && buildProduct?.internet?.isLeadListAddress && buildProduct?.isAPDataEnabled) {
      let asLowAsPrice = (parseFloat(product?.displayPrice?.replace?.("$", "")) - 20)?.toFixed?.(2);
      return asLowAsPrice;
    }
    if(buildProduct?.isVZFwdFlag){
      return InHomeUtils.getVzfwdDisplayPrice(buildProduct, asLowAsPrice)
    }
    return asLowAsPrice?.toFixed?.(2);
  };

  const checkIfRemovedInDisconnect = () => {
    if (serviceType === Service.internet || serviceType === Service.mm3) {
      return buildProduct?.internet?.disconnected;
    } else if (serviceType === Service.tv) {
      return buildProduct?.tv?.disconnected;
    } else if (serviceType === Service.voice) {
      return buildProduct?.voice?.disconnected;
    }
  };

  const isProfileServiceProductRemoved = (product)=>{
    if(product?.isprdOnProfile && (product?.id === buildProduct?.internet?.selectedProduct?.id || props?.cart?.cartData?.[0]?.serviceHeaders?.servicehead?.some?.(p => p?.prodId && p?.prodId === product?.id))){
    return false
    }else return true
  }

  const getEcCtaText = (notProfileServices,product) => {
    if (isDisconnectFlow) {
      return checkIfRemovedInDisconnect() ?  'Removed' : 'Remove';
    } else {
      if (notProfileServices) {
        return isChecked
          ? isECFlow && (product?.prodType ==="FTTPD") ? "Selected":"Remove"
          : (product?.prodType ==="FTTPD") ? (product?.isprdOnProfile && !isProfileServiceProductRemoved(product) ? "Remove" : "Select")
            : (((product?.isprdOnProfile && !isProfileServiceProductRemoved(product)) || (product?.prodType === Service.streamServ && product?.isprdOnProfile && !isPrdRemovedstrmServiceFromProfile(product, "STREAMINGSERVICES"))) ? "Remove" : "Select");
      }
      return checkIfRemovedInDisconnect() ? 'Removed' : isECFlow && Service.tv === serviceType ? 'Remove' : 'Selected';
    }
  };

  function isPrdRemovedstrmServiceFromProfile(product, subSectionType) {
    const cartRemovedProducts =
      props.cart?.cartResponse?.tierContent?.[0]?.sections?.section
        ?.find((s) => s?.sectionName === "Removed Streaming Services") ?.subSections?.subSection?.find( (s) => s?.sectionType === subSectionType)?.products;
    return Array.isArray(cartRemovedProducts)
      ? cartRemovedProducts?.some((p) => p?.prodId === product?.id)
      : false;
  }

  // function isPrdRemovedServiceFromProfile(product, subSectionType) {
  //   const cartRemovedProducts = props.cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => (s?.sectionName === "Removed Services"))?.subSections?.subSection?.find(s => s?.sectionType === subSectionType)?.products;
  //   return Array.isArray(cartRemovedProducts) ? cartRemovedProducts?.some(p => p?.prodId === product?.id) : false;
  // }

  function isProfileProductRemoved() {
    try {
      let isProductRemoved = false;
      const removedCart = Object.entries(props?.cart?.cartData?.[0])
        ?.filter(k => k?.[0]?.includes("removed") && ((!Array.isArray(k?.[1]) && k?.[1]) || (Array.isArray(k?.[1]) && k?.[1]?.length > 0)));
      if (Array.isArray(removedCart) && removedCart?.length > 0) {
        removedCart?.forEach(r => {
          if (Array.isArray(r) && r?.length > 1 && product?.id) {
            if (InHomeUtils.searchNestedObject(r?.[1], "prodId", product?.id)) {
              isProductRemoved = true;
            }
          }
        });
      }
      return isProductRemoved;
    } catch (e) {
      console.error(e)
    }
    return false;
  }

  const openChannels = (e, product) => {
    openModal(e);
    let name = product?.productName?.replace?.('4.0', '');
    setTimeout(() => {
      tempVzdlSCData.detail = name;
      updateDetailValue(name);
      updateSCTags('Channels');
    }, 1000);
    updateDetailValue(name + ' - Channels');
  };

  const handleReview = (e, product) => {
    let name = product?.productName?.replace?.('4.0', '');
    if (flowType == "EC") {
      ecupdateDetailValue(`${name} - review details `);
      if (buildProduct?.internet?.isAccordionOpen === true) {
        tempSCData.detailPageName = `${name} - review details `
        ecupdateSCcustomEvent("buildFiosInitEC", "pageViewOmni", "detailPageName,events");
      } else if (buildProduct?.tv?.isAccordionOpen === true) {
        tempSCData.detailPageName = `${name} - review details `
        ecupdateSCcustomEvent("buildFiosInitEC", "pageViewOmni", "detailPageName,events");
      }
      setTimeout(() => {
        ecupdateSCTags('Review Details', '', name);
      }, 200)
    } 
    else if(props.lqState.streamlineLQ === true){
      setTimeout(() => {
        updateDetailValue(name);
        tempVzdlSCData.detail = name;
        updateSCTags('Review Details');
      }, 1000);
      if (buildProduct?.internet?.isAccordionOpen === true) {
        tempVzdlSCData.detail = name + ' - review details'
        tempVzdlSCData.name = 'Streamline Buildproducts - Internet & Perks'
        updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,name");
      } else if (buildProduct?.tv?.isAccordionOpen === true) {
        tempVzdlSCData.detail = name + ' - review details'
        tempVzdlSCData.name = 'Streamline Buildproducts - TV & Voice'
        updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,events,name");
      }
    }
    else {
      setTimeout(() => {
        updateDetailValue(name);
        tempVzdlSCData.detail = name;
        updateSCTags('Review Details');
      }, 1000);
      if (buildProduct?.internet?.isAccordionOpen === true) {
        tempVzdlSCData.detail = name + ' - review details'
        updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,events");
      } else if (buildProduct?.tv?.isAccordionOpen === true) {
        tempVzdlSCData.detail = name + ' - review details'
        updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail,events");
      }
    }
  };

  const getProdTitleWidth = product => {
    let title = <h3 className='emberdatatitle' style={{lineHeight:product?.productName === 'Your Fios TV Spotlight' || product?.name === 'Fios TV: Mundo Total'? "23px" : product?.name==="Your Fios TV Spotlight Package"?"19px":"",width:product?.productName === 'Your Fios TV Spotlight'?"auto":""}}>{product?.productName ? product?.productName : product?.name}</h3>
    let titleWidth = '';
    if (product?.name === 'YouTube TV') {
      title = <img src='http://s7.vzw.com/is/image/VerizonWireless/YTTV%5FLogo%5FBlackType?$pngalpha$' alt='YouTube TV' ariaLabel='YouTube TV' tabIndex='0' width={(flowType == "EC" ? 110 : 130)} />
    } else if (isClassicFlow) {
      title = product?.name;
    }

    if (isMobileView && (product?.prodType === 'FTTPD')) {
      titleWidth = '90px';
    } else {
      if ((flowType == "EC" && (title === '300 Mbps' || title === '500 Mbps')) || (title === 'The Most Fios TV' || title === 'Fios TV Test Drive' || product?.name === 'YouTube TV')) {
        titleWidth = '110px';
      } else {
        titleWidth = product?.productName === 'Your Fios TV Spotlight'
          ? '146px'
          : (product?.productName === 'Fios Home Phone') ? '120px' : '130px';
      }
    }

    return {
      children: title,
      width: titleWidth
    };
  };

  const getProdPrice = (product, formattedPriceWithAP, formattedPriceWithoutAP) => {

    if (product?.prodType === 'FVPRIMARY') {
      return parseInt(product?.price?.replace?.('less', '')?.replace?.('more', ''));
    } else if (buildProduct?.isAPDataEnabled) {
      if (product?.prodType != "FTTPD") {
        if (buildProduct?.tv?.selectedProduct == null) {
          // Hardcoding YTTV price to 72.99 as per Business confirmation for MIDNITE-1591
          return (!hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE') && product?.price ? (parseFloat(product?.price) - 10)?.toFixed?.(2) : parseFloat(product?.price);
        } else if (product?.price?.toString()?.includes('more') || product?.price?.toString()?.includes('less')) {
          return product?.price?.toString?.()?.replace?.('.00', '') + '/mo*';
        } else {
          return (!hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE') && product?.price ? parseFloat(product?.price) - 10 : parseFloat(product?.price);
        }
      } else {
        if (buildProduct?.isVZFwdFlag) {
          return InHomeUtils.getVzfwdDisplayPrice(buildProduct, parseFloat(formattedPriceWithAP))
        }
        return formattedPriceWithAP;
      }
    } else if (product?.prodType != "FTTPD") {
      if (product?.prodTypeValue === 'YOUTUBE') {
        // Hardcoding YTTV price to 72.99 as per Business confirmation for MIDNITE-1591
        return (!hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE') && product?.price ? parseFloat(product?.price) - 10 : parseFloat(product?.price);
      } else {
        return (parseFloat(product?.price)) + 10; // PRODDEF-34778: YouTube TV price should not change when APO toggle is turned off, it should stay as $72.99 even when toggle is turned off
      }
    } else {
      if (buildProduct?.isVZFwdFlag) {
        return InHomeUtils.getVzfwdDisplayPrice(buildProduct, parseFloat(formattedPriceWithoutAP))
      }
      return formattedPriceWithoutAP;
    }
  };

  const getVZFwdTooltip = () => {
    return <>
      <Body size='medium' color='#ffffff'>
        Get service for as low as $0/mo for 6 months with the Verizon Forward Credit
      </Body>
      <Body size='medium' color='#6F7171'>
        Promo credit ends if eligibility requirements are no longer met. After 6 months, you will be charged the then-current price. Must install/activate eligible service by 9.30.24.
      </Body>
    </>
  };
  function getPriceGuarantee (uniqPromo) {
    let subText = '';
    subText = uniqPromo?.[2];
    let showPriceBadge = (subText!= '' && subText != undefined)? true: false;
    let newPriceGuarantee={};
    if(showPriceBadge) {
      newPriceGuarantee.priceBadge = {
        children: <span class={props?.product?.isprdOnProfile && priceGuaranteeBrandPromise ? 'priceGswatExtension' : 'priceGswat'}>
          {(props?.product?.isprdOnProfile && Array.isArray(priceGuaranteeBrandPromise) && priceGuaranteeBrandPromise?.length > 0) ? priceGuaranteeBrandPromise?.map?.((text) => (<div>{text}</div>)) : subText}
        </span>,
          fillColor : "neonYellow",
            icon : {
              name : "lock-closed"
            }
          }
   return newPriceGuarantee
    }
    else {
      return null
    }
  }
  function getEmberPrice() {
    const priceData = {};
    try {
      const floatRegex = /[+-]?\d+(\.\d+)?/g;
      const originalPrice = typeof product?.originalPrice === "string"
        ? product?.originalPrice?.match(floatRegex)?.map(x => parseFloat(x))?.[0]
        : typeof product?.price === "string"
          ? product?.price?.match(floatRegex)?.map(x => parseFloat(x))?.[0]
          : null;
      const displayPrice = typeof product?.displayPrice === "string"
        ? product?.displayPrice?.match(floatRegex)?.map(x => parseFloat(x))?.[0]
        : typeof product?.price === "string"
          ? product?.price?.match(floatRegex)?.map(x => parseFloat(x))?.[0]
          : null;
      let autoPayDiscount = 0;
      let autopayPrice = 0;
      let showStrikedOutAndAsLowAs = false;
      const is10SwatDisc =  product?.specialOffersfromApi?.findIndex(item => ["R4616","R4636"]?.includes(item?.id)) > -1 ? true : false;
      const is15SwatDisc = product?.specialOffersfromApi?.findIndex(item => ["R4617","R4637"]?.includes(item?.id)) > -1 ? true : false;
      showStrikedOutAndAsLowAs = (is10SwatDisc || is15SwatDisc) ? true : false;
      product?.specialOffersfromApi?.map?.((item, index) => {
        if(item?.BsOfferAttrValue?.toLowerCase()?.includes?.("autopay") && !item?.BsOfferAttrValue?.toLowerCase?.()?.includes?.("decline")){
          autopayPrice = Number(item?.Price);
        }
      });
      autoPayDiscount = buildProduct?.isAPDataEnabled ? 0 : autopayPrice;
      let autopayDeclined = profileCart?.cartData?.[0]?.Promotions?.promotions?.find(p => p?.offerAttrValue === "FCP_AUTOPAY_DECLINE")
        || ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.find(p => p?.offerAttrValue === "FCP_AUTOPAY_DECLINE");
      if (autopayDeclined && !(flowType==="MV" &&  props?.moveExpState?.cust_opt==="NONSEAMLESS")) {
        autoPayDiscount = buildProduct?.isAPDataEnabled ? -autoPayDiscount : 0;
      }
      let mf4MrkDiscount = 0;
      // let mf4DiscDiscount = 0;
      let ismnhDiscountIsOnProfile = false;
      ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.map((promoPrdValue, index) => {
        if(promoPrdValue.prodTypeValue == 'MF4DISCF15'){
          ismnhDiscountIsOnProfile = true;
        }
      });
      let onProfileData = profileCart?.cartData?.[0]?.Promotions?.promotions;
      onProfileData?.map((promoPrdValueMVflow, index) => {
        if(promoPrdValueMVflow?.offerAttrValue == 'MF4DISCF15' || promoPrdValueMVflow?.offerAttrValue == 'VZWPREPAID'){
          ismnhDiscountIsOnProfile = true;
        }
      });
      if (typeof displayPrice === "number" &&  buildProduct?.emberInfo?.isMF4MRKF15 && !showStrikedOutAndAsLowAs &&
        (!isMNHSignupIndicator || (isMNHSignupIndicator && !buildProduct?.emberInfo?.isMF4DISC15)) && !isECFlow ) {
        mf4MrkDiscount = buildProduct?.emberInfo?.isMF4MRKF15?.Price || 15;
        let discountPrice = displayPrice - mf4MrkDiscount + autoPayDiscount;
        if(buildProduct?.isVZFwdFlag){
          discountPrice = InHomeUtils.getVzfwdDisplayPrice(buildProduct, discountPrice)
        }
        if (buildProduct?.emberInfo?.hideEmber) {
          priceData.discountPrice = null;
        } else {
          priceData.discountPrice = {
            color: "secondary",
            leadingText: {
              children: "As low as"
            },
            price: discountPrice?.toFixed?.(2),
            term: "month",
            trailingText: {
              children: (!ismnhDiscountIsOnProfile && !isMNHSignupIndicator) ? (
                <MnhModal
                  product={product}
                  buildProduct={buildProduct}
                  mnhTooltip={product?.mnhTooltip}
                  mnhTooltipdesc={product?.mnhTooltipdesc}
                  signInClick={signInClick}
                  flowType={props.lqState.streamlineLQ}
                  dispatch={props.dispatch}
                />
              ) : "",
            },
          };
        }
        priceData.oldPrice = null;
      } else if (typeof originalPrice === "number" && isMNHSignupIndicator && !showStrikedOutAndAsLowAs && buildProduct?.emberInfo?.isMF4DISC15 && !isECFlow) {
        // mf4DiscDiscount = buildProduct?.emberInfo?.isMF4DISC15?.Price || 15;
        let oldPrice = originalPrice - 10.0 + autoPayDiscount;
        if(buildProduct?.isVZFwdFlag){
          oldPrice = InHomeUtils.getVzfwdDisplayPrice(buildProduct, oldPrice)
        }
        priceData.oldPrice = {
          leadingText: {
            children: "was"
          },
          price: oldPrice?.toFixed?.(2),
          term: "month",
        };
        priceData.discountPrice = null;
      }
      //to show both strike out price and as low as for Swat 221
      else if(showStrikedOutAndAsLowAs){
        let oldPrice = originalPrice - 10.0 + autoPayDiscount;
        mf4MrkDiscount = buildProduct?.emberInfo?.isMF4MRKF15?.Price || 15;
        let discountPrice = displayPrice - mf4MrkDiscount + autoPayDiscount;
        if(buildProduct?.isVZFwdFlag){
          oldPrice = InHomeUtils.getVzfwdDisplayPrice(buildProduct, oldPrice)
          discountPrice = InHomeUtils.getVzfwdDisplayPrice(buildProduct, discountPrice)
        }
        priceData.oldPrice = {
          leadingText: {
            children: "was"
          },
          price: oldPrice?.toFixed?.(2),
          term: "month",
        };
        if (buildProduct?.emberInfo?.hideEmber) {
          priceData.discountPrice = null;
        } else {
          priceData.discountPrice = {
            color: "secondary",
            leadingText: {
              children: "As low as"
            },
            price: discountPrice?.toFixed?.(2),
            term: "month",
            trailingText: {
              children: (!ismnhDiscountIsOnProfile && !isMNHSignupIndicator) ? (
                <MnhModal
                  product={product}
                  buildProduct={buildProduct}
                  mnhTooltip={product?.mnhTooltip}
                  mnhTooltipdesc={product?.mnhTooltipdesc}
                  signInClick={signInClick}
                  flowType={props.lqState.streamlineLQ}
                  dispatch={props.dispatch}
                />
              ) : "",
            },
          };
        }
      }
      if (typeof displayPrice === "number") {
        // let newPrice = displayPrice - mf4DiscDiscount + autoPayDiscount;
        let newPrice = displayPrice + autoPayDiscount;  // In the Ember program, BE will manage the display price based on auth and unauth scenarios.
        const hasVzfwdNyDiscount= ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.find(p => p?.OfferAttrValue === "VZFORWARD_NY_BROADBAND_DISCOUNT")
        const hasVzfwdDiscount= ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.find(p => p?.OfferAttrValue === "VZP_NEWFIOSFORWARDSTANDALONE_DISCOUNT")
        if(buildProduct?.isVZFwdFlag || hasVzfwdDiscount || hasVzfwdNyDiscount){
          newPrice = InHomeUtils.getVzfwdDisplayPrice(buildProduct, newPrice, hasVzfwdNyDiscount)
        }
        priceData.newPrice = {
          price: newPrice?.toFixed?.(2),
          term: "month",
        }
      }
    } catch (e) {
      console.error(e);
    }
    return priceData;
  }

  function getPlanSavings() {
    let planSavings = {
      savings: {
        title: null,
        items: [],
      }
    };
    try {
      let perkGift = getPerkGiftDts("savings", product, serviceType, buildProduct, profileCart, ecProfileCart);
      if (perkGift) {
        planSavings.savings.title = {
          children: <span class='More_Value'>More value for mobile customers</span>,
        };
        planSavings.savings.items.push({
          icon: {
            name: getIcon(perkGift.icon),
            alignment: "top",
            color: "red",
            size: "medium",
            ariaHidden: true,
          },
          title: {
            children: perkGift.title,
          },
          subtitle: {
            children: perkGift.subtitle,
          },
        });
      } else if (buildProduct?.internet?.mnhSignupIndicator === "Y" && buildProduct?.emberInfo?.isEmberFlow) {
        planSavings.savings.title = {
          children: <span className="transparent">More value for mobile customers</span>,
        };
        planSavings.savings.items.push({
          icon: {
            name: getIcon("gift"),
            alignment: "top",
            color: "red",
            size: "medium",
            ariaHidden: true,
          },
          title: {
            children: <span className="transparent">Get a perk, on us</span>,
          },
          subtitle: {
            children: <span className="transparent">Save up to $10/mo on an eligible perk like Disney+, Hulu, ESPN+ (With Ads) or Netflix & Max (With Ads).</span>,
          },
        });
      }
    } catch (e) {
      console.error(e);
    }
    if (planSavings.savings.items.length > 0) {
      return planSavings;
    } else {
      return null;
    }
  }

  const formatProdForSB = (product) => {
    const strikeOutPrice = getStrikeOutPrice();
    let mnhSignupIndicator = (buildProduct?.internet?.mnhSignupIndicator === 'Y' || buildProduct.isStaticMnhEnable === true) ? 'Y' : 'N';
    let isMax500plan = buildProduct?.internet?.m2mPlans?.findIndex(item => ["R3582", "R3583"].includes(item?.id)) > -1 ? false : true;
    let isGigPlan = product?.id === "R3583" || product?.id === "R3582";
    let is25MNHOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["R3728", "R3729"].includes(item?.id)) > -1 ? true : false
    let is15MNHOfferAvailable = product?.specialOffersfromApi?.findIndex(item => ["R3727"].includes(item?.id)) > -1 ? true : false
    let is20SpclOffer = product?.specialOffersfromApi?.findIndex(item => ["R4017"].includes(item.id)) > -1 ? true : false;
    //const is10NEWDisc = product?.specialOffersfromApi?.findIndex(item => ["R4616"]?.includes(item?.id)) > -1 ? true : false;
    //const is15NEWDisc = product?.specialOffersfromApi?.findIndex(item => ["R4617"]?.includes(item?.id)) > -1 ? true : false;
    let blackFridayandCyberMonArray = buildProduct?.internet?.m2mPlans?.filter(item => item?.id === "R3583" || item?.id === "R3582");
    let isBlackFridayOrCyberMonday = blackFridayandCyberMonArray[0]?.specialOffers?.findIndex(item => ["R4139", "R4093"].includes(item?.id)) > -1 ? true : false;
    let ismnhDiscountIsOnProfile = false;
      ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.map((promoPrdValue, index) => {
        if(promoPrdValue.prodTypeValue == 'MF4DISCF15'){
          ismnhDiscountIsOnProfile = true;
        }
      });
      let onProfileData = profileCart?.cartData?.[0]?.Promotions?.promotions;
      onProfileData?.map((promoPrdValueMVflow, index) => {
        if(promoPrdValueMVflow?.offerAttrValue == 'MF4DISCF15' || promoPrdValueMVflow?.offerAttrValue == 'VZWPREPAID'){
          ismnhDiscountIsOnProfile = true;
        }
      });
    let formattedPriceWithAP =
      (mnhSignupIndicator === "" &&
        !is25MNHOfferAvailable &&
        !is15MNHOfferAvailable) ||                       // handling unauth non MNH
        (mnhSignupIndicator === "Y" && (is25MNHOfferAvailable || is15MNHOfferAvailable)) // handling auth MNH
        ? (+product?.price)?.toFixed?.(2)
        : (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && isGigPlan && !isMax500plan && isNotVerizonEmployee) ? buildProduct?.isVZFwdFlag ? (((+product?.price))?.toFixed?.(2)) :  (((+product?.price) - 25)?.toFixed?.(2))
          : (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && !isMax500plan && isNotVerizonEmployee) ? buildProduct?.isVZFwdFlag ? (((+product?.price))?.toFixed?.(2)) : (((+product?.price) - 15)?.toFixed?.(2))
            : (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && isMax500plan && (product?.id == "R3584") && isNotVerizonEmployee) ? (((+product?.price) - 25)?.toFixed?.(2))
              : (mnhSignupIndicator === "Y" && !(is25MNHOfferAvailable && is15MNHOfferAvailable) && !isGigPlan && isMax500plan && (product?.id != "R3584") && isNotVerizonEmployee) ? (((+product?.price) - 15)?.toFixed?.(2))
                : (((mnhSignupIndicator === "N" && isGigPlan && !isMax500plan && is25MNHOfferAvailable && !is15MNHOfferAvailable) ||
                  (mnhSignupIndicator === "" && isGigPlan && !isMax500plan && is25MNHOfferAvailable && !is15MNHOfferAvailable)) ? (((+product?.price) + 25)?.toFixed?.(2)) :
                  ((mnhSignupIndicator === "N" && !isGigPlan && !isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable) ||
                    (mnhSignupIndicator === "" && !isGigPlan && !isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable)) ? (((+product?.price) + 15)?.toFixed?.(2)) :
                    ((mnhSignupIndicator === "N" && !isGigPlan && isMax500plan && (product?.id == "R3584") && is25MNHOfferAvailable && !is15MNHOfferAvailable) ||
                      (mnhSignupIndicator === "" && !isGigPlan && isMax500plan && (product?.id == "R3584") && is25MNHOfferAvailable && !is15MNHOfferAvailable)) ? (((+product?.price) + 25)?.toFixed?.(2)) :
                      ((mnhSignupIndicator === "N" && !isGigPlan && isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable) ||
                        (mnhSignupIndicator === "" && !isGigPlan && isMax500plan && !is25MNHOfferAvailable && is15MNHOfferAvailable)) ? (((+product?.price) + 15)?.toFixed?.(2)) :
                        (+product?.price)?.toFixed?.(2)
                );
    
    let autopayDiscount = 0;
    let autopayPrice = 0;
    product?.specialOffersfromApi?.map?.((item, index) => {
      if (item?.BsOfferAttrValue?.toLowerCase()?.includes?.("autopay") && !item?.BsOfferAttrValue?.toLowerCase?.()?.includes?.("decline")) {
        autopayPrice = Number(item?.Price);
      }
    });
    autopayDiscount = buildProduct?.isAPDataEnabled ? 0 : autopayPrice;
    let formattedPriceWithoutAP = +formattedPriceWithAP && ((+formattedPriceWithAP) + autopayDiscount)?.toFixed?.(2)

    const isTWSFlow = buildProduct?.internet?.typeOfDiscountScenario === "TWS"
      || buildProduct?.internet?.typeOfDiscountScenario === "TSW"
      || buildProduct?.isTWSFlag === "Y";
      
    isShowAsLowPrice = isTWSFlow ? true : (mnhSignupIndicator === "Y") ? false : ((mnhSignupIndicator === "N" || mnhSignupIndicator === "") && !(is25MNHOfferAvailable || is15MNHOfferAvailable)) ? true : false

    let formattedAsLowPriceWithAP= mnhSignupIndicator === "" && !is25MNHOfferAvailable && !is15MNHOfferAvailable
        ? (+product?.price - +product?.mnhDiscount)?.toFixed?.(2)
        : (+product?.price)?.toFixed?.(2);

    let formattedAsLowPriceWithoutAP = +formattedAsLowPriceWithAP && ((+formattedAsLowPriceWithAP) + 10)?.toFixed?.(2);
    const disableTV = ((buildProduct?.internet?.selectedProduct === null && product?.prodTypeValue === "ULTIMATETESTDRIVE") ||
      (buildProduct?.internet?.selectedProduct === null && product?.prodTypeValue === "YOUTUBE" && buildProduct?.internet?.m2mPlans?.filter((each) => each.isprdOnProfile && !each.isprdRemoved).length === 0))
    const uniqPromo = [...new Set(product?.equipPromo)]?.filter(n => n);
    let is5YearPriceGuarantee = uniqPromo?.findIndex(item => item?.toLowerCase()?.includes('5-year price guarantee')) > -1 ? true : false;
    //to show as low as for $20 - swat 179
    // if (is20SpclOffer && buildProduct?.internet?.isLeadListAddress) {
    //   isShowAsLowPrice = false;
    //   if (isGigPlan) {
    //     isShowAsLowPrice = buildProduct?.isAPDataEnabled ? true : false;
    //   }
    // }
    //isShowAsLowPrice = (is10NEWDisc || is15NEWDisc) &&  buildProduct?.isAPDataEnabled? false: true; 
    //to show as low as for black friday and cyber monday without lead list so that it doesn't collide with swat179
    if (isBlackFridayOrCyberMonday && (buildProduct?.internet?.isLeadListAddress != true) && mnhSignupIndicator !== "Y") {
      isShowAsLowPrice = true;
    }
    const hasPlanSavings = serviceType === Service.internet && product?.equipPromo;
    const hasTextLink = serviceType === Service.internet && product?.equipPromo && product?.reviewDetails && (hasPerkGift(product, serviceType, buildProduct, profileCart, ecProfileCart) || (buildProduct?.internet?.mnhSignupIndicator === "Y" && buildProduct?.emberInfo?.isEmberFlow));
    const args = {
      title: {
        ...getProdTitleWidth(product),
      },
      ...((strikeOutPrice && !(serviceType === Service.internet && isECFlow)) && {
        oldPrice: {
          leadingText: {
            children: 'was'
          },
          price: strikeOutPrice,
          term: 'month'
        }
      }),
      ...(!buildProduct?.isVZFCreditFlag && (!isClassicFlow && (product?.displayPrice?.replace?.("$", "")) != 0.0
        ? {
          newPrice: {
            price: getProdPrice(product, formattedPriceWithAP, formattedPriceWithoutAP),
            term: buildProduct?.tv?.selectedProduct !== null && product?.type === 'TV' && (product?.price?.toString()?.includes('more') || product?.price?.toString()?.includes('less')) ? "none" : "month",
            leadingText: {
              children: product?.productName === 'Fios Home Phone' ? '' : '',
            },
            superscript: (product?.type === 'TV' || serviceType == Service.tv) ? (!hasYouTubeProfile && product?.prodTypeValue === 'YOUTUBE' && lqState?.runtimeKey?.enableYTTV === 'Y' ?  lqState?.runtimeKey?.enablePromoFooterNotes === 'Y' ? '**' : '1' : '*') : '',
            alignment: 'right',
            size: 'medium'
          },
          ...(!hasYouTubeProfile && lqState?.runtimeKey?.enhanceYTTV === 'Y' && product?.prodTypeValue === 'YOUTUBE' && {
            oldPrice: {
              leadingText: {
                children: <s>reg</s>
              },
              price: product?.originalPrice ? product?.originalPrice : "82.99",
              term: "month",
              strikethrough: true
            },
            autoPayPrice: {
              trailingText: {
                children: <span style={{ fontSize: "0.70rem" }}>for new subscribers</span>
              },
              size: '2XSmall',
              price: '',
              color: 'secondary',
              term: 'none',
              hideCurrency: true
            },
            buttonIcon: {
              disabled: false,
              renderIcon: () => (
                <InfoIcon
                  ariaLabel="More information about New Youtube TV subscribers save $10/mo for 12 months tooltip"
                  color="#6e6b65"
                  size="small"
                  surface="light"
                />
              ),
              onClick: () => {
                setYoutubeTvTooltipOpen(true);
              },
            },
            discountPrice: {
              leadingText: {
                children: 'for 1 year'
              },
              size: '2XSmall',
              alignment: 'right',
              price: '',
              term: 'none',
              color: 'secondary',
              hideCurrency: true,
            }
          })
        } : isClassicFlow ? generateClassicDisplayPrice(product?.displayPrice, product) : '')),
      ...(isShowAsLowPrice && !isEmployee && !buildProduct?.isVZFCreditFlag && product?.mnhDiscount && !isECFlow && {
        discountPrice: {
          color: 'secondary',
          leadingText: {
            children: <div style={{marginTop: buildProduct?.isVZFwdFlag && parseFloat(product?.displayPrice?.replace?.("$", ""))== 0 ? "35px" : ""}}>As low as</div>,
          },
          price: (!ismnhDiscountIsOnProfile && !isMNHSignupIndicator) ? getAsLowAsPrice() : '',
          term: (!ismnhDiscountIsOnProfile && !isMNHSignupIndicator) ? "month" : '',
          trailingText: {
            children: (!ismnhDiscountIsOnProfile && !isMNHSignupIndicator) ? (<MnhModal product={product}
            buildProduct={buildProduct} mnhTooltip={product?.mnhTooltip}
              formattedWasPriceWithAP={formattedAsLowPriceWithAP}
              signInClick={signInClick} 
              flowType = {props.lqState.streamlineLQ}              
              dispatch = {props.dispatch}
              />) : ''
          },
        }
      }),
      ...(buildProduct?.isVZFCreditFlag && {
        newPrice: {
          price: '0',
          term: "month"
        },
        discountPrice: {
          trailingText: {
            children: 'after 6 mos'
          },
          price: (parseFloat(product?.displayPrice?.replace?.('$', '')))?.toFixed?.(2),
          term: 'none',
          tooltip: {
            surface: 'light',
            maxHeight: '120px',
            ariaLabel: 'More information about verizon forward credit tooltip',
            title: InHomeUtils.getdeviceType() === 'desktop' ? 'Verizon Forward 6 Credit' : 'Get discounted service for 6 months with the Verizon Forward Credit',
            children: getVZFwdTooltip()
          }
        }
      }),
      ...(serviceType === Service?.internet && buildProduct?.emberInfo?.isEmberFlow  ? getEmberPrice() : null),
      ...((serviceType === Service.internet || serviceType=== Service.mm3)&&!isClassicFlow &&  lqState?.runtimeKey?.PriceGuarantee =='Y' ? getPriceGuarantee(uniqPromo):null ),
      details: {
        transparentBackground :true,
        items: uniqPromo?.map((equip, index) => {
          let subtitle = "";
          if (equip?.includes("|")) {
            const titleNSub = equip?.split("|");
            equip = titleNSub[0];
            subtitle = titleNSub[1];
          }
          let newPriceGuarantee = false;
          if(equip?.toLowerCase?.()?.includes?.('3-year price lock guarantee') || equip?.toLowerCase?.()?.includes?.('4-year price lock guarantee') || equip?.toLowerCase?.()?.includes?.('5-year price lock guarantee')|| equip?.toLowerCase?.()?.includes?.('2-year price guarantee')||equip?.toLowerCase?.()?.includes?.('3-year price guarantee')||equip?.toLowerCase?.()?.includes?.('4-year price guarantee')){
            newPriceGuarantee = true;
          }
          return {
            ...(!isClassicFlow &&!(props?.lqState?.runtimeKey?.PriceGuarantee =='Y' && newPriceGuarantee)  && serviceType === 'INTERNET' &&  { icon: { name: getIcon(equip),alignment: 'top',  size: 'large', ariaHidden: true} ,}),
            title: {
              children: (props?.lqState?.runtimeKey?.PriceGuarantee =='Y' && newPriceGuarantee) ? '' : (<span dangerouslySetInnerHTML={{ __html: equip }} style={{ position: serviceType === 'INTERNET' ? 'relative' : '' , top: serviceType === 'INTERNET' ? '4px' : ''}} />)
            },
            subtitle: {
              children: subtitle?.toLowerCase?.()?.includes('available for a limited time') ? <span style={{ left: 32, position: 'relative' ,bottom:'32px'}} >{subtitle}</span> : subtitle
            }
          }
        }),
        ...((serviceType == "TV"
          ? product?.reviewTVDetails
          : product?.equipPromo && !hasTextLink) && {
          leftTextLink: {
            tabIndex: -1,
            role:"option",
            ariaLabel:"clickable",
            onClick: (e) => { handleReview(e, product) },
            onTouchStart: (e) => { handleReview(e, product) },
            onKeyDown: (e) => {
              if (e.keyCode === 32 || e.keyCode === 13) {
                handleReview(e, product);
                e.preventDefault();
              }
            },
            children: product?.reviewDetails ? (
              <ReviewDetailsModal
                toggleButton={
                  <button
                    aria-hidden={true}
                    className="reviewDetailsbtn"
                    aria-label={product?.productName}
                    tabIndex={0}
                    role="button"
                    aria-roledescription="Review details button"
                  >
                    Review details
                  </button>
                }
                onClose={(e) => { handleCloseSignClick(e) }}
                {...getReviewDts(isClassicFlow && product?.name === 'YouTube TV' ? product?.classicDetails : product?.reviewDetails, product)}
              />
            ) : (
              <></>
            ),
          }
        }),
        ...((serviceType == "TV" && achorLinkTitleForTV === "See channels" || (serviceType == "TV" && isClassicFlow && product?.name !== 'YouTube TV')) && {
          rightTextLink: {
            children: (
              <>
                <span className="screen-reader-only">Open modal showing</span>
                Channels
                <span className="screen-reader-only">for {productNameChannelLabel()}</span>
              </>
            ),
            onClick: (e) => { openChannels(e, product) },
            ariaLabel: productNameChannelLabel() + ' Channels list',
            id: `DETAIL_${product?.id}`
          }
        })
      },
      ...(hasPlanSavings
        ? getPlanSavings()
        : null
      ),
      ...(hasTextLink
        ? {
          textLink: {
            children: (
              <ReviewDetailsModal
                toggleButton={
                  <button
                    aria-hidden={false}
                    className="reviewDetailsbtn"
                    aria-label={product?.productName}
                    tabIndex={0}
                    role="menu"
                    aria-roledescription="Review details"
                  >
                    Review details
                  </button>
                }
                onClose={(e) => { handleCloseSignClick(e) }}
                {...getReviewDts(isClassicFlow && product?.name === 'YouTube TV' ? product?.classicDetails : product?.reviewDetails, product)}
              />
            ),
          }
        }
        : null
      ),
      ...(!isClassicFlow && product?.extras?.length > 0 && serviceType !== 'INTERNET' && { contentTile: (product?.prodType != 'FVPRIMARY') ? formatExtras(product) : '' }),
      // CETC-146259 Suppressing special offer section if there are no special offers, the serviceType is not internet, the flowtype is classic, and the flowtype is ec
      ...(!isClassicFlow && product?.splOferFrmApi?.length > 0 && (product?.specialOffersfromApiArr?.[0]?.length > 0 || product?.specialOffersfromApiArr?.[1]?.length > 0) && serviceType === "INTERNET" && flowType !== "AF" && { extras: formatExtrasForData(product) }),

      ...((typeof ecProfileCart?.ProfileDataProduct?.prodId == product?.id != "undefined" && ecProfileCart?.ProfileDataProduct?.prodId == product?.id && buildProduct?.internet?.selectedProduct == null && !props?.cart?.cartData?.[0]?.serviceHeaders?.servicehead?.some?.(p => p?.prodType && p?.prodType === ProductType.INTERNET_PLAN)) || (typeof ecProfileCart?.ProfileTVProduct?.prodId == product?.id != "undefined" && ecProfileCart?.ProfileTVProduct?.prodId == product?.id && buildProduct?.tv?.selectedProduct == null) || (flowType === 'SUPP' && buildProduct?.internet?.selectedProduct?.id == product?.id) ?
        {
          footer: {
            buttonGroup: {
              childWidth: "100%",
              alignment: "center",
              rowQuantity: {
                desktop: 1,
                mobile: 1,
                tablet: 1,
              },
              data: [
                {
                  surface: "dark",
                  children: getEcCtaText(),
                  ariaLabel: product?.name && !isChecked ? 'Selected' + product?.productName?.replace?.('4.0', '') : 'Removed' + product?.name?.replace?.('4.0', ''),
                  disabled: isBlocked ? true : disableTV,
                  use: "secondary",
                  onClick: (e) => {
                    if (serviceType === Service.tv && !isDisconnectFlow && product?.prodTypeValue === "Fios_Five") {
                      handleClickFiosFive(e);
                    } else {
                      e.stopPropagation();
                      clickFn();
                    }
                  },
                },
              ],
            },
          }
        }
        :
        {
          footer: {
            buttonGroup: {
              childWidth: "100%",
              alignment: "center",
              rowQuantity: {
                desktop: 1,
                mobile: 1,
                tablet: 1,
              },
              data: [
                {
                  surface: isChecked ? "dark" : "light",
                  children: getEcCtaText(true,product),
                  id:product?.prodType ==="FTTPD" && isECFlow ? "btn-selected" : '',
                  ariaLabel: product?.name && !isChecked ? 'Selected' + product?.name?.replace?.('4.0', '') : 'Removed' + product?.productName?.replace?.('4.0', ''),
                  disabled: isBlocked ? true : disableTV,
                  use: ((product?.prodType ==="FTTPD" || product?.type == "TV") && product?.isprdOnProfile && isProfileServiceProductRemoved(product)) ? "primary":(isDisconnectFlow || isChecked || (product?.isprdOnProfile && !isProfileProductRemoved())) ? "secondary" : "primary",
                  onClick: (e) => {
                    if (serviceType === Service.tv && product?.prodTypeValue === "Fios_Five") {
                      handleClickFiosFive(e);
                    } else {
                      e.stopPropagation();
                      clickFn();
                    }
                  },
                },
              ],
            },
          }
        }
      ),
      ...(((!isEmployee && serviceType != "FIOS_VOICE") || (isEmployee && serviceType !== Service.internet && serviceType != "FIOS_VOICE")) && {
        banner: {
          icon: { name: product?.banner && (product?.prodTypeValue !== "YOUTUBE" || (product?.prodTypeValue === "YOUTUBE" && lqState?.runtimeKey?.enableYTTV === 'Y')) ? getIcon(product?.banner?.split(" ")?.[0]) : '', ariaHidden: true },
          children: <>
            {(product?.prodTypeValue !== "YOUTUBE" || (product?.prodTypeValue === "YOUTUBE" && lqState?.runtimeKey?.enableYTTV === 'Y') && product?.banner) ? product?.banner : (disableTV ? 'Internet plan required' : '')}
            {lqState?.runtimeKey?.enableYTTV === 'Y' && product?.prodTypeValue === "YOUTUBE" && product?.banner && <> <YouTubeBannerDetails isBanner={true} product={product} /></>}
          </>,
          ...(product?.banner && product?.bannerTooltip && product?.bannerTooltipTitle && {
            tooltip: {
              ariaLabel: `More information about ${product?.bannerTooltipTitle} tooltip`,
              children: (<>
                <b>{product?.bannerTooltipTitle}</b>
                <br /><br />
                {product?.bannerTooltip}
              </>),
            },
          }),
          ...((product?.prodTypeValue !== "YOUTUBE" || (product?.prodTypeValue === "YOUTUBE" && lqState?.runtimeKey?.enableYTTV === 'Y') && product?.banner) && { fillColor: 'red' }),
          ...(!product?.banner && { fillColor: tileTheme }),
        }
      }),
      backgroundColor: tileTheme,
    };
    return args;
  };

  const replaceDynamicVals = (title) => {
    const dynamicMap = {
      ytSupportedDevs:
        "https://support.google.com/youtubetv/answer/7129767?visit_id=1-636403200064571702-3219702076&p=supported_devices&rd=1",
      ytOfferTerms: "https://tv.youtube.com/learn/offer-terms/",
      ytOfferTermsLink: "https://tv.youtube.com/learn/offer-terms/",
      buyRouterImg:
        "https://www.verizon.com/content/dam/verizon/personal/accordion-images/banners/WHW.png",
      rayBanImg:
        "https://www.verizon.com/content/dam/verizon/personal/accordion-images/raybansmartGlasses.png",
      samsungImg:
        "https://www.verizon.com/content/dam/verizon/personal/accordion-images/home-depot-offer.png",
      samsungModalLink:
        "https://www.homedepot.com/b/Featured-Products-Eligible-Samsung-Appliances/N-5yc1vZ2fkpf1p",
      fiostvLink:
        "https://sales-bau-sit3-publisher.ebiz.verizon.com/content/dam/verizon/personal/accordion-images/fiostv+.png",
    };
    // if(title?.includes('{{') && title?.includes('}}')) {

    // }
    return title
      ?.replace?.("{{ytSupportedDevs}}", dynamicMap.ytSupportedDevs)
      ?.replace?.("{{ytOfferTerms}}", dynamicMap.ytOfferTerms)
      ?.replace?.("{{ytOfferTermsLink}}", dynamicMap.ytOfferTermsLink)
      ?.replace?.("{{buyRouterImg}}", dynamicMap.buyRouterImg)
      ?.replace?.("{{colon}}", ":")
      ?.replace?.("{{rayBanImg}}", dynamicMap?.rayBanImg)
      ?.replace?.("{{fiostvLink}}", dynamicMap?.fiostvLink)
      ?.replace?.("{{samsungImg}}", dynamicMap.samsungImg)
      ?.replace?.("{{samsungModalLink}}", dynamicMap?.samsungModalLink);
  };

  const closeReviewModel = (e, title) => {
    setIsCloseButton(true);
    let titleValue = title?.mainTitle ? title.mainTitle : product?.productName;
    updateDetailValue(titleValue + " - review details");
    updateSCTags("close button");
    document.getElementById("close-button").click();
  };

  const getReviewDts = (reviewDts, product) => {
    try {
      const title = reviewDts[0];

      if (Array.isArray(reviewDts) && reviewDts.length > 0) {
        reviewDts?.shift();
        let perkGift = getPerkGiftDts("review", product, serviceType, buildProduct, profileCart, ecProfileCart);
        if (perkGift) {
          reviewDts.push(perkGift);
        }
      }
      return {
        title: {
          children: product?.productName
            ? product?.productName
            : product.id === "R3577"
            ? "Your Fios TV Spotlight"
            : "",
          primitive: "h2",
        },
        list: reviewDts?.map((dt) => {
          const title = isClassicFlow ? replaceDynamicVals(dt.title) : dt.title;
          return {
            title: {
              children: <span dangerouslySetInnerHTML={{ __html: title }} />,
              size: "medium",
              bold: true,
              primitive: "h3",
            },
            subtitle: {
              children: (
                <span
                  style={{ fontSize: "1rem" }}
                  dangerouslySetInnerHTML={{ __html: dt.subtitle }}
                />
              ),
            },
            helperText: {
              children: (
                <span
                  className="reviewDetailsText"
                  dangerouslySetInnerHTML={{ __html: dt.helperText }}
                />
              ),
              // children: (
              //   <span
              //     style={{ fontSize: "0.6875rem" }}
              //     dangerouslySetInnerHTML={{__html: dt.helperText}}
              //   />
              // ),
            },
            icon: {
              name: dt.icon,
            },
          };
        }),
        buttonData: {
          primary: {
            children: "Close",
            style: "margin-bottom: 20px",
            // onClick: () => document.getElementById('close-button').click()
            onClick: (e) => { closeReviewModel(e, title) },
            onKeyDown: (e) => { 
              if (e.keyCode === 13 || e.keyCode === 32) {
                closeReviewModel(e, title)
              }
            }
          }
        },
        theme: "monarch",
      };
    } catch (e) {
      return null;
    }
  };

  let planHomeClass = "";
  if (tileTheme) {
    planHomeClass += ` tile-theme-${tileTheme}`;
  }
  if (isMobileView) {
    planHomeClass += " tile-theme-mobile";
  }
  if (serviceType === Service.internet && product?.equipPromo) {
    if (hasPerkGift(product, serviceType, buildProduct, profileCart, ecProfileCart)) {
      planHomeClass += " emberHasSavingsSection";
    } else if (buildProduct?.internet?.mnhSignupIndicator === "Y" && buildProduct?.emberInfo?.isEmberFlow) {
      planHomeClass += " emberNoSavingsSection";
    }
  }
  return (
    <>
      <React.Suspense fallback={<></>}>
        <div id="plan-home-modals">
          {hasYoutubeTvTooltip && (
            <YoutubeTvTooltipModal
              price={product?.displayPrice}
              opened={isYoutubeTvTooltipOpen}
              onOpenedChanged={(modalOpened) => { setYoutubeTvTooltipOpen(modalOpened) }}
            />
          )}
        </div>
      </React.Suspense>
      <div id="plan-home-modals" className={product?.name==="Local TV" ?  localTv  : ''}></div>
      <PlanHome className={planHomeClass} {...formatProdForSB(product)} />
    </>
  );
};


const mapStateToProps = (state) => {
  return {
    buildProduct: state.buildProduct,
    cart: state.cart,
    flowType: state.app.flowType,
    lqState: state.loopQual,
    ecProfileCart: state.ecProfileCart,
    signIn: state.signIn,
    profileCart:state.profileCart,
    modalWindow:state.modalWindow,
    moveExpState: state.moveExp,
  };
};

export default connect(mapStateToProps)(EmberPlanHome);